<template>
  <div>
    <SimpleTable
      ref="simpleTable"
      class="extended-table"
      :class="{ 'no-selection': noSelection }"
      :items="list"
      :fields="tableFields"
      :selectable="!noSelection"
      :select-mode="'range'"
      @selected="selected = $event"
      @row-clicked="handleRowClick"
    >
      <template #cell(typeProperties)="{item}">
        <div
          class="px-2 font-weight-bold"
          style="padding-block: 1px; font-size: 1em; width: 75px"
        >
          <i
            :class="item.typeProperties.icon"
            :style="{ 'color': item.typeProperties.color}"
            class="pr-1"
          />
          {{ item.typeProperties.text }}
        </div>
      </template>
      <template #cell(statusProperties)="{item}">
        <div
          :style="{ 'background-color': item.statusProperties.color }"
          class="badge badge-success text-white"
        >
          <div
            class="px-2 status-badge text-uppercase font-weight-bold"
          >
            <i
              :class="item.statusProperties.icon"
              class="pr-1"
            />
            <span>
              {{ item.statusProperties.text }}
            </span>
          </div>
        </div>
      </template>
      <template #cell(created)="{item}">
        <div>
          {{ item.created }}
        </div>
      </template>
      <template #cell(duration)="{item}">
        <div>
          {{ item.duration }}
        </div>
      </template>
    </SimpleTable>
  </div>
</template>

<script>
import SimpleTable from '@/components/tables/SimpleTable';

export default {
  props: {
    list: Array,
    tableFields: Array,
    noSelection: Boolean,
  },
  data: () => ({
    selected: null,
  }),
  components: {
    SimpleTable,
  },
  methods: {
    async handleRowClick(selected, index, ev) {
      const tagetClassList = ev.target.classList;
      if (
        tagetClassList.contains('square-box')
        || tagetClassList.contains('color-box-container')
        || tagetClassList.contains('clickable')
      ) {
        return;
      }

      this.checkboxPopover = false;
      this.$emit('selected', selected);
    },
  },
};
</script>

<style scoped lang="scss">
  @import "~@/styles/vars.icss";

  .extended-table :deep(th) {
    padding: 0 0.75rem !important;
  }

  .extended-table.no-selection :deep(tr) {
    cursor: default !important;

    &:hover {
      background-color: transparent !important;
    }
  }

  .extended-table :deep(tr) {
    transition: 0.2s all;
    cursor: pointer;

    .color-box.square-box {
      transition: 0.2s all;
    }

    &:hover {
      background-color: #ECECEC;

      .color-box.square-box {
        background-color: #D4D4D4 !important;
      }
    }
  }

  .extended-table :deep(thead) {
    tr {
      height: 40px !important;
    }
  }

  .extended-table :deep(tbody) {
    tr {
      height: 40px;
    }
  }

  .extended-table :deep(.left-options) {
    min-width: 40px;
    max-width: 40px;
  }

  .extended-table :deep(externalId) {
    text-align: left !important;
  }

  .status-badge {
    width: 100px;
    line-height: 1.3em;
    white-space: pre-wrap;
  }

</style>
